// import Vue from 'vue'
import APIBase from './APIBase'
import Session from '../session/Session'

var api = new APIBase('portal')


api.findTenant = function (tid) {
  return api.GET('/tenant/' + tid)
}

api.findProperty = function (name) {
  return api.GET('/property/' + name)
}

api.queuesByTenant = function (tid, sz) {
  return api.GET('/queue/tenant/' + tid + '?sz=' + sz || 'xs')
}

api.activeNewsByTenant = function (tenantId) {
  return api.GET(`/news/tenant/${tenantId}/active`)
}

api.setLanguage = function (id) {
  return api.GET('/setlang/' + id)
}

api.servicepointbyQueue = function (qid, sz) {
  return api.GET('/servicepoint/queue/' + qid + '?sz=' + sz || 'xs')
}

api.findSlots = function (queueID, serviceID, channelID) {
  return api.GET('/ticket/freeslots/' + queueID + '/' + serviceID + '/' + channelID)
}

api.issueTicket = function (t) {
  return api.POST('/ticket/issue', t)
}

api.myTickets = function (payload) {
  return api.POST('/ticket/mytickets', payload)
}

api.cancelTicket = function (id) {
  return api.PUT('/ticket/cancel/' + id)
}

api.checkinTicket = function (id) {
  return api.GET(`/ticket/checkin/${id}`)
}

api.getTeleconfURL = async () => {
  let h = await api.findProperty("TELECONF_URL");
  Session.setTeleconfURL(h.data.value);
  window.console.log(`Se ha recuperado TELECONF_URL=${Session.getTeleconfURL()}` )
}

api.resguardoURL = function (id) {
  return APIBase.getApiURL() + this.entityClass + `/ticket/resguardo/${id}`
}

export default api
